import { render, staticRenderFns } from "./UserPages.vue?vue&type=template&id=7e7851a2&scoped=true&"
import script from "./UserPages.vue?vue&type=script&lang=ts&"
export * from "./UserPages.vue?vue&type=script&lang=ts&"
import style0 from "./UserPages.vue?vue&type=style&index=0&id=7e7851a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7851a2",
  null
  
)

export default component.exports